var map = {
	"./AlertGreen.png": 80614,
	"./AlertRed.png": 4602,
	"./GPSGreen.png": 23846,
	"./GPSRed.png": 86411,
	"./IgnitionOn.png": 72625,
	"./IgnitionStop.png": 13439,
	"./MapIcon.png": 87675,
	"./PowerGreen.png": 10420,
	"./PowerRed.png": 83926,
	"./ShareIcon.png": 13001,
	"./all.png": 52800,
	"./canbus.png": 52659,
	"./idle.png": 36100,
	"./no-data.png": 61428,
	"./not-reported.png": 80365,
	"./power-cut.png": 53221,
	"./running.png": 13415,
	"./stopped.png": 16600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81341;